import { useQuery } from '@tanstack/react-query';
import { permissionDemoApi } from '../api/permissionDemoApi';
import type { MyPermissionsResponse, ApiError } from '../types/permissionDemo';

/**
 * Query: GET /api/eraf/permission-demo/me/permissions
 * Auto-fires on page mount. Uses RequestContextHolder server-side (no DB).
 * p95 target < 100ms.
 */
export function useMyPermissions() {
  return useQuery<MyPermissionsResponse, ApiError>({
    queryKey: ['permission-demo', 'my-permissions'],
    queryFn: () => permissionDemoApi.getMyPermissions(),
    retry: false,
    staleTime: 30_000,
  });
}
